document.addEventListener("DOMContentLoaded", function () {
  
  // 1. Build image mapping arrays safely from layout nodes
  let imageOverrides = {};
  const manifestContainer = document.getElementById("StepUpImageSubstitionManifestBlockDataConfig");
  if (manifestContainer) {
    try {
      imageOverrides = JSON.parse(manifestContainer.textContent);
    } catch (e) {
      console.error("Failed to parse visual config data overrides mapping matrix", e);
    }
  }

  // Preloader Engine to stop all tracking latency flickering
  function preloadImageSource(url) {
    if (!url) return;
    const preloadImg = new Image();
    preloadImg.src = url;
  }

  Object.values(imageOverrides).forEach(src => preloadImageSource(src));
  document.querySelectorAll('.stepup-promo-hover-item').forEach(link => {
    preloadImageSource(link.getAttribute('data-img-src'));
  });
  document.querySelectorAll('.stepup-dynamic-hover-link').forEach(link => {
    preloadImageSource(link.getAttribute('data-auto-img'));
  });

  // 2. Control Layout Mega Menu Panels
  const megaDropdowns = document.querySelectorAll('.stepup-mega-dropdown');

  megaDropdowns.forEach(dropdown => {
    const leftPanelLinks = dropdown.querySelectorAll('.stepup-dynamic-hover-link');
    const rightPromoLinks = dropdown.querySelectorAll('.stepup-promo-hover-item');
    const defaultGrid = dropdown.querySelector('.default-visual-grid-frame');
    const hoverFrame = dropdown.querySelector('.stepup-hover-frame');
    const targetImage = dropdown.querySelector('.stepup-target-showcase-img');

    // Action function to seamlessly inject preview showcases
    function switchShowcaseImage(imgSrc) {
      if (imgSrc && targetImage) {
        targetImage.src = imgSrc;
        if (defaultGrid) defaultGrid.classList.add('stepup-hidden-element');
        if (hoverFrame) hoverFrame.classList.remove('stepup-hidden-element');
      }
    }

    leftPanelLinks.forEach(link => {
      const handle = link.getAttribute('data-img-target');
      
      // Determine image source priority: 1. Manual block override | 2. Auto collection image fallback
      let resolvedSrc = imageOverrides[handle] || link.getAttribute('data-auto-img');
      
      if (resolvedSrc) {
        link.setAttribute('data-hover-src', resolvedSrc);

        link.addEventListener('mouseenter', function() {
          switchShowcaseImage(this.getAttribute('data-hover-src'));
        });
        link.addEventListener('click', function() {
          switchShowcaseImage(this.getAttribute('data-hover-src'));
        });
      }
    });

    rightPromoLinks.forEach(link => {
      link.addEventListener('mouseenter', function() {
        switchShowcaseImage(this.getAttribute('data-img-src'));
      });
      link.addEventListener('click', function() {
        switchShowcaseImage(this.getAttribute('data-img-src'));
      });
    });

    // Dismiss preview frames cleanly on window departures
    dropdown.addEventListener('mouseleave', function() {
      if (defaultGrid && hoverFrame && targetImage) {
        defaultGrid.classList.remove('stepup-hidden-element');
        hoverFrame.classList.add('stepup-hidden-element');
        targetImage.src = "";
      }
    });
  });

  // 3. Search Field Action Interceptor
  const searchToggle = document.getElementById('StepUpSearchToggleBtn');
  const searchContainer = document.getElementById('StepUpSearchDropdownContainer');

  if (searchToggle && searchContainer) {
    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      searchContainer.classList.toggle('is-open');
      
      if (searchContainer.classList.contains('is-open')) {
        const searchInput = searchContainer.querySelector('.stepup-search-inner-input');
        if (searchInput) setTimeout(() => searchInput.focus(), 100);
      }
    });

    document.addEventListener('click', function (e) {
      if (!searchContainer.contains(e.target) && !searchToggle.contains(e.target)) {
        searchContainer.classList.remove('is-open');
      }
    });
  }

  // 4. Mobile Layout Accordion Switches
  const mobileMenuBtn = document.getElementById("StepUpMobileMenuBtn");
  const wrapperSection = document.getElementById("StepUpHeaderSection");

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener("click", function () {
      wrapperSection.classList.toggle("mobile-open");
    });
  }

  const chevronToggles = document.querySelectorAll(".stepup-mobile-accordion-chevron-trigger-toggle-btn");
  chevronToggles.forEach(toggle => {
    toggle.addEventListener("click", function () {
      this.classList.toggle("is-rotated");
      const parentNode = this.closest(".stepup-mobile-accordion-node-item");
      const submenuTray = parentNode.querySelector(".stepup-mobile-accordion-child-submenu-tray-wrapper");
      if (submenuTray) {
        submenuTray.classList.toggle("is-visible");
      }
    });
  });
});




document.addEventListener("DOMContentLoaded", function () {
  const searchBtn = document.getElementById("StepUpSearchToggleBtn");
  const searchContainer = document.getElementById("StepUpSearchDropdownContainer");

  if (searchBtn && searchContainer) {
    // Toggle dropdown display when clicking search icon
    searchBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      searchContainer.classList.toggle("is-open");

      // Auto-focus input when opened
      if (searchContainer.classList.contains("is-open")) {
        const input = searchContainer.querySelector("input");
        if (input) setTimeout(() => input.focus(), 100);
      }
    });

    // Close when clicking anywhere outside
    document.addEventListener("click", function (e) {
      if (!searchContainer.contains(e.target) && !searchBtn.contains(e.target)) {
        searchContainer.classList.remove("is-open");
      }
    });

    // Prevent closing when clicking inside the search box/results
    searchContainer.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  }
});